import http from "./http";
import firebase from "firebase";
import config from "../config";
import RandomValues from "../utils/random";
import EventEmitter from 'eventemitter3';

const readCircleEmitter = new EventEmitter();
const deleteCircleEmitter = new EventEmitter();
const randomValues = new RandomValues();

export default class CircleService {
  validate(obj) {
    if (
      obj.code === 200 &&
      obj.data !== null &&
      obj.data !== {} &&
      obj.data !== [] &&
      obj.data.length !== 0 &&
      Object.keys(obj.data).length !== 0
    ) {
      return true;
    }
    return false;
  }

  getDefaultCircle(header) {
    return new Promise((resolve, reject) => {
      http.get("circle/read_default", { headers: header })
        .then(body => {
          body = body["data"];
          if (body["code"] === 200) {
            resolve(body["data"]);
          } else {
            reject(body);
          }
        }).catch((err) => reject(err));
    });
  }

  getDefaultIdentity(header) {
    return new Promise((resolve, reject) => {
      http.get("identity/read_default", { headers: header }).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve(body["data"]);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  addProfileIdentity(identity, header) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("value", identity["value"]);
      form.append("profile_id", identity["profile"]);
      form.append("identity_id", identity["identity"]);
      if (header) {
        http.post("profile_identity/create", form, { headers: header }).then(body => {
          body = body["data"];
          if (body["code"] === 200) {
            resolve();
          } else {
            reject(body);
          }
        }).catch((err) => reject(err));
      } else {
        http.post("profile_identity/create", form).then(body => {
          body = body["data"];
          if (body["code"] === 200) {
            resolve();
          } else {
            reject(body);
          }
        }).catch((err) => reject(err));
      }
    });
  }

  addToDefaultCircle(profile, header) {
    return new Promise((resolve, reject) => {
      this.getDefaultIdentity(header)
        .then(identity_id => {
          this.addProfileIdentity(
            {
              value: profile.user.name,
              profile: profile.user._id,
              identity: identity_id
            },
            header
          ).then(() => {
            this.getDefaultCircle(header).then(circle_id => {
              const form = new FormData();
              form.append('circle_id', circle_id);
              form.append('profile_id', profile.user._id);
              form.append('type', 'role');
              form.append('status', 'default');

              http.post("board/create", form, { headers: header }).then(body => {
                body = body["data"];
                if (body["code"] === 200) {
                  resolve();
                } else {
                  reject(body);
                }
              }).catch((err) => reject(err));
            }).catch(error => {
              reject(error);
            });
          })
            .catch(error => {
              reject(error);
            });
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  getProfileCircles(profile_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("profile_id", profile_id);
      http.post("board/read_by_profile", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          if (body.data.length > 0) {
            const userBoards = body.data;

            http.get("circle/read_all").then(body => {
              body = body["data"];
              if (body["code"] === 200) {
                const circles = body.data.filter(s => s.status === 'active');
                const _circles = userBoards.map(b => {
                  const circle = circles.find(s => s._id === b.circle_id);
                  if (circle) {
                    circle.icon = circle.upload ? circle.upload.path : null;
                    circle.visible = circle.flags ? (circle.flags.findIndex(flag => flag.type.toLowerCase() === "visibility").value.toLowerCase() === "public" > -1) : true;
                    return circle;
                  }
                });
                resolve(_circles.filter(s => s));
              } else {
                reject(body);
              }
            }).catch((err) => reject(err));
          } else {
            resolve([]);
          }
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  getProfileCircleSections(profile_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("profile_id", profile_id);
      http.post("circle/read_by_profile", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          if (Object.keys(body.data).length > 0) {
            resolve(body.data)
          } else {
            resolve({});
          }
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  getPublicCircles(limit, page) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("limit", limit);
      form.append("page", page);
      http.post("circle/index", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve(body.data.data)
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  getCurrentUserCircles(profile_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("profile_id", profile_id);
      http.post("board/read_by_profile", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          if (body.data.length > 0) {
            const userBoards = body.data;

            http.get("circle/read_all").then(body => {
              body = body["data"];
              if (body["code"] === 200) {
                const circles = body.data.filter(s => s.status === 'active');

                const _circles = userBoards.map(b => circles.find(s => s._id === b.circle_id)).filter(s => s);

                const fetchCirclePromises = _circles.map(_circle => {
                  return new Promise((resolve, reject) => {
                    const form = new FormData();
                    form.append("_id", _circle._id);
                    http.post("circle/read", form).then(body => {
                      body = body["data"];
                      if (body["code"] === 200) {
                        const circle = body["data"][0];
                        if (circle) {
                          circle.flags.find(
                            flag => flag.type.toLowerCase() === "visibility"
                          ).value.toLowerCase() === "public"
                            ? (circle.visible = true)
                            : (circle.visible = false);

                          circle.icon = circle.upload ? circle.upload.path : null;
                        }
                        resolve(circle);
                      } else {
                        reject(body);
                      }
                    }).catch((err) => reject(err));
                  });
                });

                Promise.all(fetchCirclePromises).then(res => resolve(res)).catch(err => reject(err));
              } else {
                reject(body);
              }
            }).catch((err) => reject(err));
          } else {
            resolve([]);
          }
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  readCircle(id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("_id", id);
      http.post("circle/read", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          const circle = body["data"][0];
          if (circle) {
            circle.flags.find(
              flag => flag.type.toLowerCase() === "visibility"
            ).value.toLowerCase() === "public"
              ? (circle.visible = true)
              : (circle.visible = false);

            circle.icon = circle.upload ? circle.upload.path : null;
          }
          resolve(circle);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  getCircleMembership(profile_id, circle_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('profile_id', profile_id);
      form.append('circle_id', circle_id);
      http.post("board/read_by_circle_profile", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          body["data"].length > 0 ? resolve(true) : resolve(false);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  readCircleChildren(parent) {
    return new Promise((resolve, reject) => {
      const promises = parent.children.map(s => this.readCircle(s.child));
      Promise.all(promises).then(circles => {
        if (circles) {
          circles.map(circle => {
            if (circle) {
              circle.parent_id = parent._id;
            }
          });
        }
        resolve(circles);
      }).catch(err => reject(err));
    });
  }

  addLocation(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("title", obj.title);
      form.append("description", obj.description);
      form.append("latitude", obj.latitude);
      form.append("longitude", obj.longitude);
      form.append("tag", obj.tag);
      form.append("status", obj.status);
      form.append("profile_id", obj.profile_id);
      form.append("circle_id", obj.circle_id);

      http.post("location/create", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          obj._id = body["data"];
          resolve(obj);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  deleteLocation(location_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("_id", location_id);

      http.post("location/delete", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve();
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  editLocation(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("_id", obj._id);
      form.append("title", obj.title);
      form.append("description", obj.description);
      form.append("latitude", obj.latitude);
      form.append("longitude", obj.longitude);
      form.append("tag", obj.tag);
      form.append("status", obj.status);
      form.append("profile_id", obj.profile_id);
      form.append("circle_id", obj.circle_id);

      http.post("location/update", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve(obj);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  editCircle(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("_id", obj._id);
      form.append("title", obj.title);
      form.append("upload_id", obj.upload_id);
      form.append("status", obj.status);

      http.post("circle/update", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve(obj);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  editCircleFlag(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("_id", obj._id);
      form.append("type", obj.type);
      form.append("value", obj.value);
      form.append("status", obj.status);
      form.append("circle_id", obj.circle_id);

      http.post("flag/update", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve(obj);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  changeCircleIcon(icon) {
    return new Promise((resolve, reject) => {
      this.uploadImage(icon).then((url) => {
        let form = new FormData();
        form.append("title", randomValues.secureRandString());
        form.append("path", url);
        form.append("tag", icon.circle._id);
        http.post("upload/create", form).then(body => {
          body = body["data"];
          if (body["code"] === 200) {
            const upload_id = body.data;
            form = new FormData();
            form.append("_id", icon.circle._id);
            form.append("title", icon.circle.title);
            form.append("upload_id", upload_id);
            form.append("status", icon.circle.status);

            http.post("circle/update", form).then(body => {
              body = body["data"];
              if (body["code"] === 200) {
                form = new FormData();
                form.append("_id", upload_id);
                http.post("upload/read", form).then(body => {
                  body = body["data"];
                  if (body["code"] === 200) {
                    const upload = body.data[0];
                    const circle = icon.circle;
                    if (upload) {
                      circle.upload = upload;
                      circle.upload_id = upload_id;
                      circle.icon = upload.path;
                    }
                    resolve(circle);
                  } else {
                    reject(body);
                  }
                }).catch((err) => reject(err));
              } else {
                reject(body);
              }
            }).catch((err) => reject(err));
          } else {
            reject(body);
          }
        }).catch(err => reject(err));
      }).catch(err => reject(err));
    })
  }

  uploadImage(image) {
    return new Promise((resolve) => {
      firebase.auth().signInWithEmailAndPassword(config.firebaseDefaultUser.email, config.firebaseDefaultUser.password)
        .then(async () => {
          const promise = new Promise((resolve, reject) => {
            const ref = firebase.storage().ref(`/uploads/circle/${image.circle._id}/icon/${randomValues.secureRandString()}`)
              .put(image.file);

            ref.on("state_changed", () => { }, () => reject(), () => {
              ref.snapshot.ref.getDownloadURL().then((url) => resolve(url));
            })
          });
          promise.then((url) => resolve(url)).catch(() => reject({ message: "An error occurred. Please try again." }))
        }).catch(() => reject({ message: "An error occurred. Please try again." }))
    });
  }

  deleteIdentity(identity_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("_id", identity_id);

      http.post("identity/delete", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve();
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  addIdentity(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("title", obj.title);
      form.append("status", obj.status);
      form.append("circle_id", obj.circle_id);

      http.post("identity/create", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          obj._id = body.data;
          if (obj.tags && obj.tags.length) {
            let tags_request = obj.tags.map(tag => {
              let tag_form = new FormData()
              tag_form.append('value', tag)
              tag_form.append('identity_id', obj._id)
              return http.post('identity_tag/create', tag_form)
            })
            Promise.all(tags_request).then(response => {
              resolve(obj);
            }).catch(err => {
              reject(err[0])
            })
          } else {
            resolve(obj);
          }
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  updateIdentity(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append("_id", obj._id);
      form.append("title", obj.title);
      form.append("status", obj.status);
      form.append("circle_id", obj.circle_id);

      http.post("identity/update", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          obj._id = body.data; 
          resolve(obj);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }


  addIdentityTag(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('value', obj.value);
      form.append('identity_id', obj.identity_id);
      http.post("identity_tag/create", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          obj._id = body.data;
          resolve(obj);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  removeIdentityTag(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('_id', obj._id);
      http.post("identity_tag/delete", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          obj._id = body.data;
          resolve(obj);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  changeMemberRole(member, role) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('_id', member._id);
      form.append('circle_id', member.circle_id);
      form.append('profile_id', member.profile_id);
      form.append('type', 'role');
      form.append('status', role);

      http.post("board/update", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          member.status = role;
          resolve(member);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    })
  }

  removeMember(member, identities) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append('_id', member._id);

      http.post("board/delete", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          form = new FormData();
          form.append('profile_id', member.profile_id);
          http.post("profile_identity/read_by_profile", form).then(async (body) => {
            body = body["data"];
            if (body["code"] === 200) {
              const profile_identities = body.data;
              let deletePIDs = [];

              identities.map(identity => {
                deletePIDs = [...deletePIDs, ...profile_identities.filter(s => {
                  return s.identity_id === identity._id
                })];
              });

              const promises = deletePIDs.map(pID => {
                return new Promise((resolve) => {
                  function deleteIdentity() {
                    const _form = new FormData();
                    _form.append('_id', pID._id);
                    return http.post("profile_identity/delete", _form).then(() => {
                      resolve();
                    }).catch(() => deleteIdentity());
                  }
                  deleteIdentity();
                });
              });
              await Promise.all(promises);
              resolve();
            } else {
              reject(body);
            }
          }).catch((err) => reject(err));
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  joinCircle(requirements, circle_id, profile_id) {
    return new Promise((resolve, reject) => {
      const identityPromises = requirements.map(s => {
        const identity = { value: s.value, identity: s._id, profile: profile_id };
        return this.addProfileIdentity(identity, null);
      });
      Promise.all(identityPromises).then(() => {
        const form = new FormData();

        form.append('circle_id', circle_id);
        form.append('profile_id', profile_id);
        form.append('type', 'role');
        form.append('status', 'default');

        http.post("board/create", form).then(body => {
          body = body["data"];
          if (body["code"] === 200) {
            const board = { circle_id, profile_id, type: "role", status: "default", _id: body.data };
            resolve(board);
          } else {
            reject(body);
          }
        }).catch((err) => reject(err));
      }).catch(err => reject(err));
    });
  }

  deleteCircle(circle_id) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append('_id', circle_id);

      http.post("circle/delete", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve();
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  addCircleFlag(obj) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append("type", obj.type);
      form.append("value", obj.value);
      form.append("status", "active");
      form.append("circle_id", obj.circle_id);

      http.post("flag/create", form).then(body => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve();
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  addCircle(obj) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append("title", obj.title);
      form.append("upload_id", obj.upload_id);
      form.append("status", obj.status);

      http.post("circle/create", form).then(async (body) => {
        body = body["data"];
        if (body["code"] === 200) {
          const circle_id = body.data;
          const flagPromises = obj.flags.map(f => {
            const flag = {
              type: f.type,
              value: f.value,
              circle_id
            };
            return this.addCircleFlag(flag);
          });

          Promise.all(flagPromises).then(() => {
            const identityPromises = obj.requirements.map(s => {
              const identityObj = {
                title: s.value,
                status: "active",
                circle_id
              };
              return this.addIdentity(identityObj);
            });

            Promise.all(identityPromises).then(() => {
              const boardObj = {
                circle_id,
                profile_id: obj.profile_id,
                type: 'role',
                status: 'owner'
              }

              this.addUserToCircleBoard(boardObj).then(() => {
                this.readCircleRecursive(circle_id);
                readCircleEmitter.on("readComplete", payload => {
                  resolve(payload.circle);
                })
              }).catch((err) => {
                this.deleteCircleRecursive(circle_id);
                deleteCircleEmitter.on("deleteComplete", () => {
                  reject(err);
                });
              });
            }).catch((err) => {
              this.deleteCircleRecursive(circle_id);
              deleteCircleEmitter.on("deleteComplete", () => {
                reject(err);
              });
            });
          }).catch(err => {
            this.deleteCircleRecursive(circle_id);
            deleteCircleEmitter.on("deleteComplete", () => {
              reject(err);
            })
          })
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  addChildCircle(obj) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append("title", obj.title);
      form.append("upload_id", obj.upload_id);
      form.append("status", obj.status);

      http.post("circle/create", form).then(async (body) => {
        body = body["data"];
        if (body["code"] === 200) {
          const circle_id = body.data;
          const flagPromises = obj.flags.map(f => {
            const flag = {
              type: f.type,
              value: f.value,
              circle_id
            };
            return this.addCircleFlag(flag);
          });

          Promise.all(flagPromises).then(() => {
            const identityPromises = obj.requirements.map(s => {
              const identityObj = {
                title: s.value,
                status: "active",
                circle_id
              };
              return this.addIdentity(identityObj);
            });

            Promise.all(identityPromises).then(async () => {
              const boardPromises = obj.boards.map(s => {
                const boardObj = {
                  circle_id,
                  profile_id: s.profile_id,
                  type: s.type,
                  status: s.status
                }
                return this.addUserToCircleBoard(boardObj);
              });

              Promise.all(boardPromises).then(() => {
                const chainObj = {
                  parent: obj.parent_id,
                  child: circle_id
                }

                this.createCircleChain(chainObj).then((chain_id) => {
                  chainObj._id = chain_id
                  this.readCircleRecursive(circle_id);
                  readCircleEmitter.on("readComplete", payload => {
                    resolve({ circle: payload.circle, chain: chainObj });
                  });
                }).catch((err) => {
                  this.deleteCircleRecursive(circle_id);
                  deleteCircleEmitter.on("deleteComplete", () => {
                    reject(err);
                  });
                });
              }).catch((err) => {
                this.deleteCircleRecursive(circle_id);
                deleteCircleEmitter.on("deleteComplete", () => {
                  reject(err);
                });
              });
            }).catch(err => {
              this.deleteCircleRecursive(circle_id);
              deleteCircleEmitter.on("deleteComplete", () => {
                reject(err);
              })
            });
          }).catch(err => {
            this.deleteCircleRecursive(circle_id);
            deleteCircleEmitter.on("deleteComplete", () => {
              reject(err);
            })
          })
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  createCircleChain(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('parent', obj.parent);
      form.append('child', obj.child);
      form.append('status', "active");

      http.post("chain/create", form).then(async (body) => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  addUserToCircleBoard(obj) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('circle_id', obj.circle_id);
      form.append('profile_id', obj.profile_id);
      form.append('type', obj.type);
      form.append('status', obj.status);

      http.post("board/create", form).then(async (body) => {
        body = body["data"];
        if (body["code"] === 200) {
          resolve();
        } else {
          reject(body);
        }
      }).catch((err) => reject(err));
    });
  }

  readCircleRecursive(circle_id) {
    this.readCircle(circle_id).then((circle) => {
      readCircleEmitter.emit("readComplete", { circle });
    }).catch(e => {
      this.readCircleRecursive(circle_id);
    });
  }

  deleteCircleRecursive(circle_id) {
    this.deleteCircle(circle_id).then(() => {
      deleteCircleEmitter.emit("deleteComplete");
    }).catch(() => {
      this.deleteCircleRecursive(circle_id);
    });
  }

  removeDuplicates = arr => {
    const newArray = [];
    arr.forEach(el => {
      if (
        newArray.findIndex(elem => elem.profile_id === el.profile_id) === -1
      ) {
        newArray.push(el);
      }
    });
    return newArray;
  };

  sortInDescendingOrder = arr => {
    return arr.sort((a, b) => {
      const [A, B] = [a.created, b.created];
      if (A < B) {
        return 1;
      }
      if (A > B) {
        return -1;
      }
      return 0;
    });
  };

  delete() {
    const form = new FormData();
    form.append('_id', "5e3cf47b6cf1166f5840012a");

    http.post('profile_identity/delete', form);
  }

  addUserToCircleUsingPhone(phone, role, circle_id) {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append('phone', phone);

      http.post('profile/read_by_phone', form).then(body => {
        body = body.data;

        if (body.code === 200) {
          const profile = body.data[0];

          if (profile) {
            form = new FormData();

            form.append('circle_id', circle_id);
            form.append('profile_id', profile._id);
            form.append('type', 'role');
            form.append('status', role);

            http.post("board/create", form).then(body => {
              body = body["data"];
              if (body["code"] === 200) {
                const board = { circle_id, profile_id: profile._id, profile, type: "role", status: role, _id: body.data, created: (Date.now() / 1000) };
                resolve(board);
              } else {
                reject(body);
              }
            }).catch((err) => reject(err));
          } else {
            reject({ message: 'We were unable to find a user with that phone number' });
          }
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  searchCircles(query) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('query', query);

      http.post('circle/search', form).then(body => {
        body = body.data;

        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  getRecommendedCircles() {
    return new Promise((resolve, reject) => {
      http.get('circle/read_recommended').then(body => {
        body = body.data;

        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    })
  }

  getBlog(limit, page) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('limit', limit);
      form.append('page', page);

      http.post('circle/blog_read', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  getCovid19Tracker(limit, page) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      //form.append('limit', limit);
      //form.append('page', page);

      http.post('circle/covid19_tracker', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  getCircleGene(identifier, limit, page) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('vanity_identifier', identifier);
      http.post('circle/gene_read', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  submitGene(form) {
    return new Promise((resolve, reject) => {
      http.post('media/gene_submit', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  submitCovid19Tracker(form) {
    return new Promise((resolve, reject) => {
      http.post('media/covid19_submit', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  getCall(limit, page) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      //form.append('limit', limit);
      //form.append('page', page);

      http.post('circle/call_for_volunteers', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  submitCall(form) {
    return new Promise((resolve, reject) => {
      http.post('media/call_submit', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  getCircleTopics(circle_id, limit, page) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('circle_id', circle_id);
      form.append('limit', limit);
      form.append('page', page);

      http.post('topic/read_by_circle', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  getCirclePolly(identifier, limit, page) {
    
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('limit', limit);
      form.append('page', page);
      form.append('vanity_identifier', identifier);

      http.post('circle/polly_read', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
    
  }

  getCircleIdentities(circle_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('circle_id', circle_id);
      http.post('identity/read_by_circle', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }

  // Vanity-ish methods
  getCircleVanity(circle_id) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('parent_id', circle_id);
      http.post('vanity/read_by_parent', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data[0]);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }
  readCircleVanityByIdentity(vanity_url) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('identity', vanity_url);
      http.post('vanity/read_by_identity', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data[0]);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }
  readCircleVanityByType(type) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('type', type);
      http.post('vanity/read_by_type', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }
  
  createVanity(data) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('parent_id', data.parent_id)
      form.append('type', data.type)
      form.append('identity', data.identity)

      http.post('vanity/create', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body.data);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }
  updateVanity(data) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('_id', data._id)
      form.append('parent_id', data.parent_id)
      form.append('type', data.type)
      form.append('identity', data.identity)

      http.post('vanity/update', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }
  
  deleteVanity(data) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('_id', data._id)

      http.post('vanity/delete', form).then(body => {
        body = body.data;
        if (body.code === 200) {
          resolve(body);
        } else {
          reject(body);
        }
      }).catch(err => reject(err));
    });
  }
}
